module.exports = __webpack_public_path__ + "static/media/home3.373c8d98.jpg";